/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface LogoutResponse {}

class LogoutService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "logout");
    }

    public async logout(resolved: (response: LogoutResponse) => void, rejected: (error: any) => void) {
        await super.getJSON((json: any) => {
            const response = json as LogoutResponse;
            resolved(response);
        }, rejected);
    }
}

export default LogoutService;
